import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: () =>
      import('./views/Login.vue')
  },
  {
    path: '/redefinir-senha/:token/:email',
    component: () =>
      import('./views/ResetPass.vue')
  },
  {
    path: '/dashboard',
    component: () =>
      import('./views/Dashboard.vue'),
    children: [{
      path: '/dashboard/produtos',
      component: () =>
        import('./views/Products.vue')
    },
    {
      path: '/dashboard/pilares',
      component: () =>
        import('./views/Pillars.vue')
    },
    ]
  },

  {
    path: '/job/:id',
    component: () =>
      import('./views/Job.vue')
  },

  {
    path: '/job/token/:token',
    component: () =>
      import('./views/Candidate.vue')
  },
  {
    path: '/job/candidato/:id',
    component: () =>
      import('./views/Candidate.vue')
  },

  {
    path: '/cliente',
    component: () =>
      import('./views/client/Dashboard.vue'),
    meta: { title: 'NS Support' },
    children: [
      {
        path: '/cliente/dashboard',
        component: () =>
          import('./views/client/Jobs.vue')
      }, {

        path: '/cliente/acompanhamento',
        component: () =>
          import('./views/client/Attendance.vue')
      },
      {
        path: '/cliente/perfil',
        component: () =>
          import('./components/Perfil.vue')
      },
      {
        path: '/cliente/conta',
        component: () =>
          import('./components/Account.vue')
      },
      {
        path: '/cliente/job/novo',
        component: () =>
          import('./views/client/NewJob.vue')
      },
      {
        path: '/cliente/job/:id',
        component: () =>
          import('./views/client/Job.vue')
      },
      {
        path: '/cliente/relatorios',
        component: () =>
          import('./views/client/Report.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () =>
      import('./views/LoginWhiteLabel.vue')
  },
  {
    path: '/',
    component: () =>
      import('./views/client/remote/Dashboard.vue'),
    children: [
      {
        path: '/atendimento',
        component: () =>
          import('./views/client/remote/Remote.vue')
      }, {
        path: '/meus-dados',
        component: () =>
          import('./views/client/remote/Perfil.vue')
      },
      {
        path: '/avaliacao',
        component: () =>
          import('./views/client/remote/Vote.vue')
      }]
  },
  {
    path: '/avalie',
    component: () => import('./views/client/remote/Rate.vue'),
  },
  {
    path: '/parceiro/onboarding',
    component: () =>
      import('./views/supporter/Onboarding.vue'),
    meta: { title: 'Onboarding - NS Support' }
  },
  {
    path: '/supporter',
    component: () =>
      import('./views/supporter/Dashboard.vue'),
    meta: { title: 'NS Support' },
    children: [{
      path: '/supporter/dashboard',
      component: () =>
        import('./views/supporter/JobsView.vue')
    },
    {
      path: '/pendencias',
      component: () =>
        import('./views/supporter/Pendency.vue')
    },
    {
      path: '/parceiro/perfil',
      component: () =>
        import('./views/supporter/Perfil.vue')
    },
    /*  {
         path: '/parceiro/pagamento',
         component: () =>
             import('./views/supporter/Bank.vue')
     }, */
    {
      path: '/parceiro/documentos',
      component: () =>
        import('./views/supporter/Documents.vue')
    },
    {
      path: '/supporter/conta',
      component: () =>
        import('./components/Account.vue')
    },
    {
      path: '/supporter/candidaturas',
      component: () =>
        import('./components/ApplyJob.vue')
    },
    {
      path: '/supporter/extrato',
      component: () =>
        import('./components/Extract.vue')
    },
    {
      path: '/supporter/minha-equipe',
      component: () =>
        import('./views/supporter/MySupporters.vue')
    },
    ]
  },
  {
    path: '/supporter/novo',
    component: () =>
      import('./views/supporter/NewSupporter.vue')
  },
  {
    path: '/supporter/usuario/:token',
    component: () =>
      import('./views/supporter/CreateSupporter.vue')
  },
  {
    path: '/funcionario',
    component: () =>
      import('./views/admin/Dashboard.vue'),
    meta: { title: 'NS Support' },
    children: [
      {
        path: '/funcionario/materiais',
        component: () =>
          import('./views/admin/Materiais.vue')
      },
      {
        path: '/funcionario/contratos',
        component: () =>
          import('./views/admin/Contratos.vue')
      },
      {
        path: '/funcionario/analise-receita',
        component: () =>
          import('./views/admin/AnaliseReceita.vue')
      },
      {
        path: '/funcionario/retorno',
        component: () =>
          import('./views/admin/Returns.vue')
      },
      {
        path: '/funcionario/lista',
        component: () =>
          import('./views/admin/Funcionarios.vue')
      }, {
        path: '/funcionario/importacoes',
        component: () =>
          import('./views/admin/Imports.vue')
      }, {
        path: '/funcionario/extrato-supporter',
        component: () =>
          import('./views/admin/ExtractSupporter.vue')
      }, {
        path: '/funcionario/permissoes',
        component: () =>
          import('./views/admin/Permissions.vue')
      },
      {
        path: '/funcionario/supporters',
        component: () =>
          import('./views/admin/Supporters.vue')
      },
      {
        path: '/funcionario/nuh',
        component: () =>
          import('./views/admin/Nuh.vue')
      },
      {
        path: '/funcionario/vtal',
        component: () =>
          import('./views/admin/Vtal.vue')
      },
      {
        path: '/funcionario/vtal/pracas',
        component: () =>
          import('./views/admin/PracasVtal.vue')
      },
      {
        path: '/funcionario/clientes',
        component: () =>
          import('./views/admin/Clients.vue')
      },
      {
        path: '/funcionario/orientacoes',
        component: () =>
          import('./views/admin/Guidelines.vue')
      },
      {
        path: '/funcionario/pendencias',
        component: () =>
          import('./views/admin/Pendencies.vue')
      },
      {
        path: '/funcionario/candidatos-supporter',
        component: () =>
          import('./views/admin/SupporterCandidate.vue')
      },
      {
        path: '/funcionario/acompanhamento',
        component: () =>
          import('./views/admin/Attendance.vue')
      },
      {
        path: '/funcionario/jobs',
        component: () =>
          import('./views/admin/Jobs.vue')
      },
      {
        path: '/funcionario/jobs/:id',
        component: () =>
          import('./views/admin/Jobs.vue')
      },
      {
        path: '/funcionario/job/novo',
        component: () =>
          import('./views/admin/NewJob.vue')
      },
      {
        path: '/funcionario/comunicados',
        component: () =>
          import('./views/admin/Communications.vue')
      },
      {
        path: '/funcionario/comunicado/:id',
        component: () =>
          import('./views/admin/Communication.vue')
      },
      {
        path: '/funcionario/comunicado/supporter/:id',
        component: () =>
          import('./views/admin/CommunicationSupporter.vue')
      },
      {
        path: '/funcionario/job/:id',
        component: () =>
          import('./views/admin/Job.vue')
      },
      {
        path: '/funcionario/pagamentos',
        component: () =>
          import('./views/admin/Payment.vue')
      },
      {
        path: '/funcionario/notas-fiscais',
        component: () =>
          import('./views/admin/NF.vue')
      },
      {
        path: '/funcionario/certificados-ferramentas',
        component: () =>
          import('./views/admin/CertificateTool.vue')
      },
      {
        path: '/funcionario/parceiros',
        component: () =>
          import('./views/admin/Partners.vue')
      },
      {
        path: '/funcionario/relatorio/conta-azul',
        component: () =>
          import('./views/admin/Report.vue')
      },
      {
        path: '/funcionario/relatorio/fluxo-caixa',
        component: () =>
          import('./views/admin/CashFlow.vue')
      },
      {
        path: '/funcionario/tipo-servicos',
        component: () =>
          import('./views/admin/ServicesType.vue')
      }, {
        path: '/funcionario/flags',
        component: () =>
          import('./views/admin/Flags.vue')
      },
      {
        path: '/funcionario/base-custos',
        component: () =>
          import('./views/admin/CostsBase.vue')
      },
    ]
  }
  ]
})